function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 43",
  transform: "translate(-1081 -417)"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 4",
  cx: 36.5,
  cy: 35.5,
  rx: 36.5,
  ry: 35.5,
  transform: "translate(1081 417)",
  fill: "#e8f6f4"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 42"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon metro-loop2",
  d: "M1128.802 437.206a16.712 16.712 0 00-12.7-5.957c-9.506 0-17.212 8.21-17.212 18.338h3.233c0-8.229 6.261-14.9 13.985-14.9a13.588 13.588 0 0110.409 4.954l-5.032 5.361h11.833v-12.607zm1.288 12.381c0 8.229-6.261 14.9-13.985 14.9a13.588 13.588 0 01-10.41-4.954l5.028-5.362h-11.829v12.607l4.515-4.811a16.712 16.712 0 0012.7 5.957c9.506 0 17.212-8.21 17.212-18.338h-3.23z",
  fill: "#00a68d"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 18",
  transform: "translate(1119.106 455.924)",
  fill: "#00a68d",
  stroke: "#e8f6f4",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon open-infinity",
  d: "M1126.408 463.097a2.687 2.687 0 00-2.7 2.827 2.687 2.687 0 002.7 2.827 3.806 3.806 0 002.7-1.724 3.755 3.755 0 002.7 1.724 2.687 2.687 0 002.7-2.827 2.687 2.687 0 00-2.7-2.827 3.755 3.755 0 00-2.7 1.725 3.806 3.806 0 00-2.7-1.725zm0 1.414c.567 0 1.187.664 1.808 1.414-.622.748-1.243 1.413-1.808 1.413a1.3 1.3 0 01-1.351-1.414 1.3 1.3 0 011.351-1.413zm5.4 0a1.3 1.3 0 011.345 1.413 1.3 1.3 0 01-1.345 1.414c-.58 0-1.2-.664-1.808-1.414.617-.749 1.224-1.413 1.808-1.413z",
  fill: "#e8f6f4"
})));
var SvgInfiniteRecurring = function SvgInfiniteRecurring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 71
  }, props), _ref);
};
export default SvgInfiniteRecurring;